import LegacyHeader from '../Header';
import type { HeaderProps } from '../Header';
import { HEADER_VARIANT_COMPONENTS } from './registry';

export type { HeaderProps };

/**
 * The storefront header, dispatched by Look variant. Variants with their own
 * component (registry.ts) render it; everything else renders the original
 * Header.tsx. `minimal` chrome always wins — it is a site-level layout mode
 * (layout_chrome), not a design choice, and the legacy header owns it.
 *
 * A wrapper rather than an early return inside Header.tsx: the variant can
 * change at runtime (the Design Sandbox previews another Look in place), and
 * swapping the rendered component here keeps every variant's hook order
 * intact.
 */
export default function Header(props: HeaderProps = {}) {
  const variant = props.variant;
  const Custom = !props.minimal && variant ? HEADER_VARIANT_COMPONENTS[variant] : undefined;
  if (Custom) return <Custom {...props} />;
  return <LegacyHeader {...props} />;
}
